import React from 'react';
import {
    Box,
    Grid,
    Card,
    CardContent,
    Typography,
    List,
    ListItem,
    ListItemText
} from '@deere/fuel-react';
import Collapse from "@material-ui/core/Collapse";
import {Chip} from "@material-ui/core";

export const RatingsCategoryCard = ({
                                        categoriesList,
                                        subCategories,
                                        selectedCategoryId,
                                        categoryId,
                                        onCategoryChange,
                                        criteria,
                                        pointsList,
                                        summaryTotal
                                    }) => {


    const handleClick = (subCategoryId, categoryId) => {
        const ele = document.getElementById(`#${categoryId}-${subCategoryId}`)
        ele.scrollIntoView({behavior: "smooth"})
    };

    return (
        <Card>
            <CardContent style={{padding: 0}}>
                <Box mt={2}>
                    <Grid container alignItems="flex-start" spacing={2}>
                        <Grid item xs={12}>
                            <List disablePadding component="nav"
                                  aria-label="supplier list">
                                {categoriesList.map((item, index) => {
                                    const categoryObj = pointsList.length > 0 && pointsList.filter(pointsObj => pointsObj.id === item.id)[0]
                                    const categoryTotal = categoryObj && categoryObj.points

                                    return (
                                        <React.Fragment key={`${index}c1`}>
                                            <ListItem button
                                                      divider={categoriesList.length !== index + 1}
                                                      className="ListItem feedback-List"
                                                      selected={index === selectedCategoryId}
                                                      onClick={() => {
                                                          onCategoryChange(item.id, item.description)
                                                      }}
                                            >
                                                <ListItemText
                                                    primary={
                                                        <Grid container>
                                                            <Grid item xs={10}>
                                                                <Typography
                                                                    color="primary"
                                                                    size="md"
                                                                    component="span"
                                                                    fontWeight="semibold"
                                                                >
                                                                    {item.description}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                <Box display="flex"
                                                                     justifyContent="flex-end" pr={2}>
                                                                    <Chip size="small"
                                                                          label={item.id === 0 ? `${summaryTotal ? summaryTotal : "-"}` : `${categoryTotal ? categoryTotal : "-"}`}/>
                                                                </Box>
                                                            </Grid>
                                                        </Grid>
                                                    }
                                                />
                                            </ListItem>
                                            <>
                                                {subCategories.map((subCategory, index) => {
                                                    const categoryCriteria = criteria && criteria.filter(criteriaObj => criteriaObj.subCategory["id"] === subCategory.id &&
                                                        !(
                                                            (criteriaObj.notApplicableReason !== null && criteriaObj.overridePoints === null) ||
                                                            (criteriaObj.responseType.id !== 3 &&
                                                                (criteriaObj.feedbacks.length === 0
                                                                    ||
                                                                    (criteriaObj.feedbacks || []).every(
                                                                        feedback =>
                                                                            (feedback.feedback.notApplicable === true || feedback.feedback.feedbackId === null ||
                                                                                (feedback.feedback.rating === "" && feedback.feedback.yesNoChoice === "")    
                                                                            )
                                                                    )
                                                                ) && criteriaObj.overridePoints === null
                                                            ) ||
                                                            (criteriaObj.responseType.id === 3 && criteriaObj.quantitativeData.length === 0)
                                                        )
                                                    )

                                                    const updatedCriteriaPoints = categoryCriteria && categoryCriteria.map(item => item.overridePoints === null ? item.points : item.overridePoints)
                                                    const subCategoryTotal = updatedCriteriaPoints.reduce((prev, curr) => prev + curr, 0)
                                                    const subCategoryWeight = categoryCriteria && categoryCriteria.reduce((total, current) => total + current.weightage, 0)

                                                    return (
                                                        <Collapse
                                                            in={item.id === categoryId}
                                                            timeout="auto"
                                                            key={`${item.id}${index}`}
                                                            unmountOnExit>
                                                            <List
                                                                className="feedback-sub-list">
                                                                <ListItem button
                                                                          onClick={() => handleClick(subCategory.id, selectedCategoryId)}>
                                                                    <ListItemText>
                                                                        <Grid container>
                                                                            <Grid item xs={10}>
                                                                                <Typography
                                                                                    color="primary"
                                                                                    size="md"
                                                                                    fontWeight="regular"
                                                                                >
                                                                                    {subCategory.description}
                                                                                </Typography>
                                                                            </Grid>
                                                                            <Grid item xs={2}>
                                                                                <Box display="flex"
                                                                                     justifyContent="flex-end">
                                                                                    <Chip variant="outlined"
                                                                                          size="small"
                                                                                          label={`${subCategoryTotal}/${subCategoryWeight}`}/>
                                                                                </Box>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </ListItemText>
                                                                </ListItem>
                                                            </List>
                                                        </Collapse>
                                                    )
                                                })}
                                            </>
                                        </React.Fragment>
                                    );
                                })}
                            </List>
                        </Grid>
                    </Grid>
                </Box>
            </CardContent>
        </Card>
    );
}